import {SET_ACTIVE_FILTERS} from './constants';

const initialState = {
  activeFilters: [],
};

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_ACTIVE_FILTERS: {
      return {...state, activeFilters: action.payload};
    }
    default:
      return state;
  }
};
